export const SET_CATEGORY_PAGE_DATA = 'SET_CATEGORY_PAGE_DATA';
export const SET_CATEGORY_TOTAL_RECORDS = 'SET_CATEGORY_TOTAL_RECORDS';
export const SET_CATEGORY_PAGE = 'SET_CATEGORY_PAGE';
export const EDIT_CATEGORY = 'EDIT_CATEGORY';
export const ADD_CATEGORY = 'ADD_CATEGORY';
export const DELETE_CATEGORY= 'DELETE_CATEGORY';
export const CATEGORY_LOADING = 'CATEGORY_LOADING';
export const CATEGORY_FAILURE = 'CATEGORY_FAILURE';
export const GET_CATEGORY= 'GET_CATEGORY';
export const SET_CATEGORY_REDIRECT_URL = 'SET_CATEGORY_REDIRECT_URL';
export const GET_ALL_CATEGORY = 'GET_ALL_CATEGORY';

export const CATEGORY_PROGRESS_TYPE={
    GET_CATEGORY_LIST:"GET_CATEGORY_LIST",
    ADD_CATEGORY_PROGRESS:"ADD_CATEGORY_PROGRESS",
    EDIT_CATEGORY_PROGRESS:"EDIT_CATEGORY_PROGRESS",
    DELETE_CATEGORY_PROGRESS:"DELETE_CATEGORY_PROGRESS"
}

